<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>Kérvények</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-grid>

    <!-- ═══════════ Kérvény-szűrőpanel (megosztott: menü 4 és 6) ═══════════ -->
    <ng-template #kszuroPanel>
      <div class="biz-filterwrap">
        <div class="biz-toolbar">
          <div class="biz-search">
            <ion-icon name="search-outline"></ion-icon>
            <input type="text" placeholder="Keresés kérvényre, beküldőre…"
              [(ngModel)]="kfilter.search" (ngModelChange)="applyKervenyFilters()" />
            <ion-icon *ngIf="kfilter.search" name="close-circle" class="clear"
              (click)="kfilter.search=''; applyKervenyFilters()"></ion-icon>
          </div>

          <div class="biz-daterange" title="Beküldés dátuma szerint szűr">
            <ion-icon name="calendar-outline"></ion-icon>
            <input type="date" [(ngModel)]="kfilter.dateFrom" (ngModelChange)="applyKervenyFilters()" aria-label="Dátumtól" />
            <span class="dash">–</span>
            <input type="date" [(ngModel)]="kfilter.dateTo" (ngModelChange)="applyKervenyFilters()" aria-label="Dátumig" />
          </div>

          <button type="button" class="biz-filterbtn" [class.active]="showKFilters || aktivKSzurok()>0"
            (click)="showKFilters = !showKFilters">
            <ion-icon name="options-outline"></ion-icon>
            <span>Szűrők</span>
            <span class="badge" *ngIf="aktivKSzurok()>0">{{ aktivKSzurok() }}</span>
            <ion-icon class="chev" [name]="showKFilters ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
          </button>
        </div>

        <div class="biz-filterpanel" *ngIf="showKFilters">
          <div class="fp-section">
            <div class="fp-label">Státusz</div>
            <div class="fp-pills">
              <button type="button" class="pill" *ngFor="let s of kStatusDefs" [class.on]="kfilter.status[s.k]"
                (click)="toggleKStatus(s.k)">
                <span class="dot" [ngClass]="s.dot"></span>{{ s.nev }}
              </button>
            </div>
          </div>

          <div class="fp-grid">
            <div class="fp-field">
              <label>Kérvény típusa</label>
              <select [(ngModel)]="kfilter.kerveny" (ngModelChange)="applyKervenyFilters()">
                <option value="">Mind</option>
                <option *ngFor="let k of kervenyLista" [value]="k.id">{{ k.name }}</option>
              </select>
            </div>
          </div>

          <div class="fp-footer">
            <button type="button" class="fp-reset" (click)="resetKFilters()" [disabled]="!aktivKSzurok()">
              <ion-icon name="close-outline"></ion-icon> Szűrők törlése
            </button>
          </div>
        </div>

        <div class="biz-stats">
          <div class="stat"><span class="k">Találat</span><span class="v">{{ kDb() }} db</span></div>
          <div class="stat"><span class="k">Elbírálásra vár</span><span class="v">{{ kVar() }} db</span></div>
          <div class="stat"><span class="k">Elfogadva</span><span class="v">{{ kElfogadva() }} db</span></div>
          <div class="stat kint" *ngIf="kElutasitva()>0"><span class="k">Elutasítva</span><span class="v">{{ kElutasitva() }} db</span></div>
        </div>
      </div>
    </ng-template>

    <ion-row>
      <ion-col>
        <div id="content1">

          <div id="menu" class="row" style="text-align: center;" *ngIf="user$ && user$.jogkor">

            <ion-button [disabled]="menu==3" [color]="menu!=1 ? 'light' : 'primary'" *ngIf="lathatoKerveny('kitoltes')" (click)="menuChange(1)"
              style="min-width: 100px;">
              <div class="custom-button-content">
                <img src="assets/icon/icons8-activity-history-96.png" width="50px">
                <span>Kérvény kitöltés<br>
                </span>
              </div>
            </ion-button>
            <ion-button [disabled]="menu==3" [color]="menu!=4 ? 'light' : 'primary'" *ngIf="lathatoKerveny('sajat')" (click)="menuChange(4)"
              style="min-width: 100px;">
              <div class="custom-button-content">
                <img src="assets/icon/icons8-certificate-96.png" width="50px">
                <span>Beküldött kérvények<br>
                </span>
              </div>
            </ion-button>
            <ion-button [disabled]="menu==3 || user$?.jogkor[0]=='gondviselo'"
              [color]="menu!=2 && menu!=3 ? 'light' : 'primary'" *ngIf="lathatoKerveny('szerkeszto')" (click)="menuChange(2)" style="min-width: 100px;">
              <div class="custom-button-content">
                <img src="assets/icon/icons8-edit-96.png" width="50px">
                <span>Kérvényszerkesztő<br>
                </span>
              </div>
            </ion-button>
            <ion-button [disabled]="1  || user$?.jogkor[0]=='gondviselo'"
              [color]="menu!=5 ? 'light' : 'primary'" *ngIf="lathatoKerveny('ugyeim')" (click)="menuChange(5)" style="min-width: 100px;">
              <div class="custom-button-content">
                <img src="assets/icon/icons8-task-96.png" width="50px">
                <span>Ügyeim<br>
                </span>
              </div>
            </ion-button>
            <ion-button [disabled]="menu==3 || user$?.jogkor[0]=='gondviselo'"
              [color]="menu!=6 ? 'light' : 'primary'" *ngIf="lathatoKerveny('feladatkosar')" (click)="menuChange(6)" style="min-width: 100px;">
              <div class="custom-button-content">
                <img src="assets/icon/icons8-tasks-96.png" width="50px">
                <span>Közös feladatkosár<br>
                </span>
              </div>
            </ion-button>
            <!-- Leadás-ellenőrzés: ki NEM adta le még az adott kérvényt (és melyik gyerekre). -->
            <ion-button [disabled]="menu==3 || user$?.jogkor[0]=='gondviselo'"
              [color]="menu!=7 ? 'light' : 'primary'" *ngIf="lathatoKerveny('leadas')" (click)="menuChange(7)" style="min-width: 100px;">
              <div class="custom-button-content">
                <img src="assets/icon/icons8-task-96.png" width="50px">
                <span>Leadás-ellenőrzés<br>
                </span>
              </div>
            </ion-button>
            <span style="margin:5px;border-left:2px solid #bbb;"></span>
            <!--ion-button [disabled]="menu!=3" [color]="'light'" (click)="menuChange(1)" style="min-width: 100px;">
              <div class="custom-button-content">
                <img src="assets/icon/icons8-floppy-96.png" width="50px">
                <span>Mentés és bezárás<br>
                </span>
              </div>
            </ion-button-->
            <ion-button [disabled]="menu!=3" [color]="'light'" (click)="menuChange(1)" style="min-width: 100px;">
              <div class="custom-button-content">
                <img src="assets/icon/icons8-delete-96.png" width="50px">
                <span>Megszakítás<br>
                </span>
              </div>
            </ion-button>


            <!--ion-button color="light" (click)="openComponent('iskola')">
        <div class="custom-button-content">
          <img src="assets/icon/icons8-school-96.png" width="50px">
          <ion-label>Iskola</ion-label>
        </div>
      </ion-button-->
          </div>
        </div>


      </ion-col>
    </ion-row>





    <ion-row *ngIf="menu == 1">
      <ion-col>

        <!-- FÉLBEHAGYOTT KITÖLTÉSEK. Elöl van, mert aki ide jön, annak rendszerint ez a
             dolga: folytatni, amit elkezdett. A másik gondviselő piszkozata is itt van
             (a közös gyerekre szólók) - épp ezért lehet kettesben aláírni egy kérvényt. -->
        <ion-card class="piszkozat-lista" *ngIf="piszkozatok?.length">
          <ion-card-header>
            <ion-card-title>Félbehagyott kitöltések</ion-card-title>
          </ion-card-header>
          <ion-card-content>
            <div class="piszkozat-sor" *ngFor="let p of piszkozatok">
              <div class="piszkozat-adat">
                <b>{{ p.nev || 'Kérvény' }}</b>
                <small>
                  <span *ngIf="p.gyermek">{{ p.gyermek }} &middot; </span>
                  Mentve: {{ p.modositva | date:'yyyy. MM. dd. HH:mm' }}
                  <span *ngIf="p.masik_gondviselotol"> &middot; elkezdte: <b>{{ p.beadta }}</b></span>
                </small>
              </div>
              <div class="piszkozat-muvelet">
                <ion-button size="small" (click)="piszkozatFolytatas(p)">
                  <ion-icon slot="start" name="create-outline"></ion-icon> Folytatás
                </ion-button>
                <ion-button size="small" fill="clear" color="danger" (click)="piszkozatTorles(p)"
                  title="A félbehagyott kitöltés eldobása">
                  <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
                </ion-button>
              </div>
            </div>
          </ion-card-content>
        </ion-card>

        <ng-container *ngIf="forms">
          <ngx-datatable
            class="ngx-datatable cronomitnew fixed-header fixed-row virtualized scroll-horz selectable checkbox-selection"
            [rows]="kitolthetoKervenyek" [sortType]="SortType.single" [columnMode]="ColumnMode.force" [rowHeight]="'auto'"
            [rowClass]="getRowClass" [sorts]="[
        { prop: 'erv_kezd', dir: 'desc' }
      ]" [messages]="{emptyMessage: 'Nincs megjeleníthető adat!'}">
            <ngx-datatable-column name="Kérvény neve" prop="name">
              <ng-template let-value="value" let-row="row" ngx-datatable-cell-template style="overflow-wrap:break-word">
                <b class="mobil">Kérvény neve</b>
                <span style="text-wrap: auto;">{{ value }}</span>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Érvényesség kezdete" prop="erv_kezd">
              <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                <b class="mobil">Érvényesség kezdete</b>
                <span>{{ value | date: 'yyyy. MM. dd.' }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Műveletek">
              <ng-template let-value="value" let-row="row" ngx-datatable-cell-template let-i="rowIndex">
                <b class="mobil">Műveletek</b>
                <ion-button color="secondary" size="medium" style="margin-top:0" (click)="initForm(row)"
                  [disabled]="moment(row.erv_kezd)>moment()">
                  <ion-icon slot="start" name="create"></ion-icon> Kitöltés megkezdése

                </ion-button>
                <!--ion-button color="success" size="small" style="margin-top:0" (click)="initModal2(JSON.parse(row.users)[0],0)">
                      <ion-icon slot="icon-only" name="add-circle"></ion-icon>
      
                    </ion-button>
                    <ion-button color="tertiary" size="small" style="margin-top:0" (click)="initModal3(JSON.parse(row.users)[0],0)">
                      <ion-icon slot="icon-only" name="document"></ion-icon>
      
                    </ion-button-->
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </ng-container>



      </ion-col>
    </ion-row>



    <ion-grid *ngIf="menu == 3 && form">
      <ion-row>
        <ion-col>
          <ion-card>
            <ion-card-header>
              <ion-card-title>{{form.name}}</ion-card-title>
            </ion-card-header>
            <ion-card-content style="margin: 10px" class="bootstrap-scope" id="urlap">
              <formio [form]="form" [submission]="form.submission" [readOnly]="formReadOnly" [refresh]="refreshForm"
                [options]="options" (change)="onUrlapValtozas($event)" (submit)="onSubmit($event)"></formio>
            </ion-card-content>
            <!-- PISZKOZAT. Van olyan kérvény, amit mindkét gondviselőnek alá kell írnia,
                 ők viszont nincsenek mindig egy helyen. A félbehagyott kitöltés (a már
                 megrajzolt aláírással együtt) elmenthető, és a másik szülő fejezi be.
                 A gomb a PDF-be nem kerül bele: a képkészítés előtt elrejtjük. -->
            <div class="piszkozat-sav formio-component-button" *ngIf="!formReadOnly && !ujrageneralando">
              <ion-button size="small" fill="outline" color="medium" (click)="piszkozatMentes()">
                <ion-icon slot="start" name="save-outline"></ion-icon>
                {{ piszkozatId ? 'Piszkozat frissítése' : 'Mentés piszkozatként' }}
              </ion-button>
              <small>Beküldés nélkül elmenti, amit eddig kitöltöttél. A gyermek másik
                gondviselője is folytathatja.</small>
            </div>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>




    <div class="bootstrap-scope" [hidden]="menu != 2">
      <br>
      <ion-card>
        <ion-card-header>
          <ion-card-title>Kérvényszerkesztő</ion-card-title>
        </ion-card-header>
        <ion-card-content style="margin: 10px">
          <ion-row>
            <ion-col>
              <ion-input label="DUMMY" label-placement="stacked" fill="outline" placeholder=""
                style="display: none;"></ion-input>
              <div
                class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
                <label class="input-wrapper sc-ion-input-md" for="ion-input-szi">
                  <div class="input-outline-container sc-ion-input-md">
                    <div class="input-outline-start sc-ion-input-md"></div>
                    <div class="input-outline-notch sc-ion-input-md">
                      <div class="notch-spacer sc-ion-input-md" aria-hidden="true">Szerkesztendő kérvény</div>
                    </div>
                    <div class="input-outline-end sc-ion-input-md"></div>
                  </div>
                  <div class="label-text-wrapper sc-ion-input-md">
                    <div class="label-text sc-ion-input-md">Szerkesztendő kérvény</div>
                  </div>
                  <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s">
                    <ion-icon name="create" aria-hidden="true"></ion-icon>
                    <ionic-selectable item-content [items]="forms" itemValueField="id" [(ngModel)]="selectedForm"
                      itemTextField="name" [canSearch]="true" [canClear]="true" closeButtonText="Mégse"
                      [searchFailText]="'Nincs találat'" [searchPlaceholder]="'Keresés'" [hasInfiniteScroll]="false"
                      clearButtonText="Visszaállítás">
                    </ionic-selectable>
                  </div>
                </label>
              </div>
              <br>
            </ion-col>
            <ion-col size="auto">
              <ion-button size="medium" [disabled]="!selectedForm" (click)="loadEditor(true)">
                <ion-icon slot="start" name="open"></ion-icon>Betöltés
              </ion-button>
              <!-- MÁSOLAT: új kérvény ritkán készül nulláról. A másolat ÖNÁLLÓ sablon, új
                   azonosítóval, ezért a már beküldött kérvények sablonja érintetlen marad
                   (eddig ilyenkor a meglévőt írták át, ami visszamenőleg is megváltozott). -->
              <ion-button size="medium" color="secondary" fill="outline" [disabled]="!selectedForm"
                (click)="masolatKeszit()" title="Másolatot készít a kiválasztott kérvényből, és azt nyitja meg">
                <ion-icon slot="start" name="copy-outline"></ion-icon>Másolat
              </ion-button>
            </ion-col>
          </ion-row>
          <ion-row *ngIf="selectedForm && betoltott">
            <ion-col>
              <ion-input label="Kérvény neve" label-placement="stacked" fill="outline" placeholder=""
                [(ngModel)]="selectedForm.name">
                <ion-icon slot="start" name="newspaper" aria-hidden="true"></ion-icon>
              </ion-input>
            </ion-col><ion-col>
              <ion-input label="Érvényesség kezdete" label-placement="stacked" fill="outline" placeholder="" type="date"
                [(ngModel)]="selectedForm.erv_kezd" max="3000-12-31"><ion-icon slot="start" name="time"
                  aria-hidden="true"></ion-icon></ion-input><br>
            </ion-col>
            <ion-col>
              <ion-input label="Érvényesség vége" label-placement="stacked" fill="outline" placeholder="" type="date"
                [(ngModel)]="selectedForm.erv_vege" max="3000-12-31"><ion-icon slot="start" name="time"
                  aria-hidden="true"></ion-icon></ion-input><br>
            </ion-col>
          </ion-row>
          <ion-row *ngIf="selectedForm && betoltott">
            <ion-col size="12" sizeMd="3">
              <ion-select
                label="PDF lapméret"
                label-placement="stacked"
                fill="outline"
                interface="popover"
                [(ngModel)]="selectedForm.pdf_meret"
                (ionChange)="initPdfBeallitas(selectedForm)">
                <ion-select-option *ngFor="let meret of pdfMeretek" [value]="meret.value">
                  {{meret.label}}
                </ion-select-option>
              </ion-select>
            </ion-col>
            <ion-col size="12" sizeMd="3">
              <ion-select
                label="PDF fekvés"
                label-placement="stacked"
                fill="outline"
                interface="popover"
                [(ngModel)]="selectedForm.pdf_fekves">
                <ion-select-option *ngFor="let fekves of pdfFekvesek" [value]="fekves.value">
                  {{fekves.label}}
                </ion-select-option>
              </ion-select>
            </ion-col>
            <ion-col size="12" sizeMd="3" *ngIf="selectedForm.pdf_meret === 'custom'">
              <ion-input
                label="Szélesség (mm)"
                label-placement="stacked"
                fill="outline"
                type="number"
                min="1"
                [(ngModel)]="selectedForm.pdf_szelesseg_mm">
              </ion-input>
            </ion-col>
            <ion-col size="12" sizeMd="3" *ngIf="selectedForm.pdf_meret === 'custom'">
              <ion-input
                label="Magasság (mm)"
                label-placement="stacked"
                fill="outline"
                type="number"
                min="1"
                [(ngModel)]="selectedForm.pdf_magassag_mm">
              </ion-input>
            </ion-col>
          </ion-row>
          <ion-row *ngIf="selectedForm && betoltott">

            <ion-col>
              <ion-input label="DUMMY" label-placement="stacked" fill="outline" placeholder=""
                style="display: none;"></ion-input>
              <div
                class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
                <label class="input-wrapper sc-ion-input-md" for="ion-input-szi">
                  <div class="input-outline-container sc-ion-input-md">
                    <div class="input-outline-start sc-ion-input-md"></div>
                    <div class="input-outline-notch sc-ion-input-md">
                      <div class="notch-spacer sc-ion-input-md" aria-hidden="true">Elfogadó határozat</div>
                    </div>
                    <div class="input-outline-end sc-ion-input-md"></div>
                  </div>
                  <div class="label-text-wrapper sc-ion-input-md">
                    <div class="label-text sc-ion-input-md">Elfogadó határozat</div>
                  </div>
                  <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s">
                    <ion-icon name="create" aria-hidden="true"></ion-icon>
                    <ionic-selectable item-content [items]="csakhatarozat" itemValueField="id"
                      [(ngModel)]="selectedHatarozat" itemTextField="name" [canSearch]="true" [canClear]="true"
                      closeButtonText="Mégse" [searchFailText]="'Nincs találat'" [searchPlaceholder]="'Keresés'"
                      [hasInfiniteScroll]="false" clearButtonText="Visszaállítás">
                    </ionic-selectable>
                  </div>
                </label>
              </div>

            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <ion-button size="medium" [disabled]="!selectedForm" (click)="saveEditor()">
                <ion-icon slot="start" name="open"></ion-icon>Mentés
              </ion-button>
            </ion-col>
          </ion-row>
        </ion-card-content>
      </ion-card>
      <div [hidden]="!selectedForm || !betoltott">
        <div class="mb-2 mt-4" [hidden]="true">
          <button type="button" class="btn btn-primary" (click)="changeLanguage('hu')">Magyar</button>
          <button type="button" class="btn btn-primary mr-2" (click)="changeLanguage('en')">English</button>
        </div>
        <form-builder class="formio" [form]="form" (change)="onChange($event)" [options]="options"
          [rebuild]="rebuildEmitter.asObservable()"></form-builder>
        <hr />
        <h3 class="text-center text-muted" style="display: none;">As JSON Schema</h3>
        <div class="well jsonviewer" style="display: none;">
          <pre id="json"><code class="language-json" #json></code></pre>
        </div>
        <h3 class="text-center text-muted">Előnézet</h3>
        <div class="well jsonviewer">

          <ion-grid>
            <ion-row>
              <ion-col>
                <ion-card>
                  <ion-card-header>
                    <ion-card-title>ŰRLAP NEVE</ion-card-title>
                  </ion-card-header>
                  <ion-card-content style="margin: 10px">
                    <formio id="editorview" class="formio" [form]="form" [submission]="form.submission"
                      [refresh]="refreshForm" [options]="options" (submit)="onSubmit($event)"></formio>
                  </ion-card-content>
                </ion-card>
              </ion-col>
            </ion-row>
          </ion-grid>


        </div>
      </div>

    </div>




    <ion-row *ngIf="menu == 4">
      <ion-col>

        <ng-container *ngTemplateOutlet="kszuroPanel"></ng-container>

        <ng-container *ngIf="sajatforms">
          <ngx-datatable
            class="ngx-datatable cronomitnew fixed-header fixed-row virtualized scroll-horz selectable checkbox-selection"
            [rows]="filteredSajatforms" [sortType]="SortType.single" [columnMode]="ColumnMode.force" [rowHeight]="'auto'"
            [rowClass]="getRowClass" [sorts]="[
    { prop: 'date', dir: 'desc' },
    { prop: 'updated_at', dir: 'desc' },
    { prop: 'priority', dir: 'desc' },
    { prop: 'deadline', dir: 'desc' }
  ]" [messages]="{emptyMessage: 'Nincs megjeleníthető adat!'}">
            <ngx-datatable-column name="Kérvény neve" prop="data">
              <ng-template let-value="value" let-row="row" ngx-datatable-cell-template style="overflow-wrap:break-word">
                <b class="mobil">Kérvény neve</b>
                <span style="text-wrap: auto;">{{ value.name }}</span>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Beküldés dátuma" prop="date">
              <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                <b class="mobil">Beküldés dátuma</b>
                <span>{{ value | date: 'yyyy. MM. dd.' }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Státusz" prop="status">
              <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                <b class="mobil">Státusz</b>
                <div style="display: flex; align-items: center; gap: 0.5rem;" *ngIf="row.status == '1'">
                  <img src="assets/icon/icons8-wait-96.png" width="32px" title="Ügyintézés alatt">
                  <span>Ügyintézés alatt</span>
                </div>
                <div style="display: flex; align-items: center; gap: 0.5rem;" *ngIf="row.status == '2'">
                  <img src="assets/icon/icons8-verified-account-96.png" width="32px" title="Elfogadva">
                  <span>Elfogadva</span>
                </div>
                <!-- Készült határozat, de döntés nincs rögzítve. Eddig ez „Elfogadva"-ként
                     jelent meg – elutasító határozatnál ez a beküldőnek pont az ellenkezőjét
                     mondta volna. A rendszer nem tudja, mi áll a határozatban: ezt mondjuk. -->
                <div style="display: flex; align-items: center; gap: 0.5rem;" *ngIf="row.status == '21'">
                  <img class="ikon-szurke" src="assets/icon/icons8-verified-account-96.png" width="32px" title="Elbírálva">
                  <span>Elbírálva — a döntést a határozat tartalmazza</span>
                </div>
                <div style="display: flex; align-items: center; gap: 0.5rem;" *ngIf="row.status == '3'">
                  <img src="assets/icon/icons8-minus-96.png" width="32px" title="Elutasítva">
                  <span>Elutasítva</span>
                </div>
                <div style="display: flex; align-items: center; gap: 0.5rem;" *ngIf="row.status == '4'">
                  <img src="assets/icon/icons8-wait-96.png" width="32px" title="Hiánypótlás szükséges">
                  <span>Hiánypótlás szükséges</span>
                </div>
                <div style="display: flex; align-items: center; gap: 0.5rem;" *ngIf="row.status == '5'">
                  <!-- A visszavonás nem elutasítás: szürke, hogy semleges lezárásnak lássék. -->
                  <img class="ikon-szurke" src="assets/icon/icons8-minus-96.png" width="32px" title="Visszavonva">
                  <span class="visszavonva-cimke">Visszavonva</span>
                </div>
                <!-- Az ügyintéző indoklása: elutasításnál és hiánypótlásnál a beküldő
                     enélkül nem tudná, mi a teendő. -->
                <div class="dontes-indok" *ngIf="dontesIndoka(row) && (row.status == '3' || row.status == '4')">
                  <b>Indoklás:</b> {{ dontesIndoka(row) }}
                </div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Műveletek">
              <ng-template let-value="value" let-row="row" ngx-datatable-cell-template let-i="rowIndex">
                <b class="mobil">Műveletek</b>
                <!--ion-button color="secondary" size="small" style="margin-top:0" (click)="initForm(row)" disabled>
                  <ion-icon slot="start" name="create"></ion-icon> Hiánypótlás

                </ion-button><br-->
                <ion-button color="tertiary" size="small" style="margin-top:0" [href]="'/api/file/'+row.path">
                  <ion-icon slot="start" name="download"></ion-icon> Letöltés

                </ion-button>
                <!-- A RÓLAD SZÓLÓ HATÁROZAT. Eddig csak az ügyintéző oldalán volt
                     letölthető: a beküldő a saját ügyénél sem érte el. Csak akkor
                     jelenik meg, ha készült is - üres gomb nem mond semmit. -->
                <ion-button color="success" size="small" style="margin-top:0" *ngIf="row.hatpath"
                            [href]="'/api/file/'+row.hatpath" title="A döntésről szóló határozat letöltése">
                  <ion-icon slot="start" name="document-text-outline"></ion-icon> Határozat
                </ion-button>
                <!-- Visszavonás: nem törlés, a kérvény és a PDF megmarad, csak lezárt
                     státuszt kap. Csak elbírálás előtt lehetséges. -->
                <!-- Visszavonni csak a SAJÁT beküldést lehet: a másik gondviselő ügyét
                     látjuk, de nem nyúlunk hozzá (a kiszolgáló is így dönt). -->
                <ion-button color="danger" size="small" fill="outline" style="margin-top:0"
                            *ngIf="(row.status == '1' || row.status == '4') && !row.masik_gondviselotol"
                            (click)="visszavonas(row)">
                  <ion-icon slot="start" name="arrow-undo-outline"></ion-icon> Visszavonás
                </ion-button>
                <!-- A MÁSIK GONDVISELŐ BEADÁSA. Egy gyereknek két gondviselője lehet, és
                     eddig mindegyikük csak a sajátját látta - ebből lett a kétszer beadott
                     (vagy be nem adott) kérvény. -->
                <div class="masik-gondviselo" *ngIf="row.masik_gondviselotol">
                  <ion-icon name="people-outline"></ion-icon>
                  <span>Beadta: <b>{{ row.beadta }}</b><span *ngIf="row.gyermek"> &middot; {{ row.gyermek }}</span></span>
                </div>
                <!--ion-button color="success" size="small" style="margin-top:0" (click)="initModal2(JSON.parse(row.users)[0],0)">
                  <ion-icon slot="icon-only" name="add-circle"></ion-icon>
  
                </ion-button>
                <ion-button color="tertiary" size="small" style="margin-top:0" (click)="initModal3(JSON.parse(row.users)[0],0)">
                  <ion-icon slot="icon-only" name="document"></ion-icon>
  
                </ion-button-->
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </ng-container>



      </ion-col>
    </ion-row>






    <ion-row *ngIf="menu == 6">

      <ion-col>

        <!-- Az elbírált kérvények elvégzett feladatok: alapból nem terhelik a kosarat. -->
        <ion-toggle style="margin: 6px 4px" [(ngModel)]="csakNyitottFeladat"
                    (ionChange)="applyKervenyFilters()">
          Csak elbírálásra váró ügyek
        </ion-toggle>

        <ng-container *ngTemplateOutlet="kszuroPanel"></ng-container>

        <ng-container *ngIf="allforms">
          <ngx-datatable
            class="ngx-datatable cronomitnew fixed-header fixed-row virtualized scroll-horz selectable checkbox-selection"
            [rows]="filteredAllforms" [sortType]="SortType.single" [columnMode]="ColumnMode.force" [rowHeight]="'auto'"
            [rowClass]="getRowClass" [sorts]="[
    { prop: 'date', dir: 'desc' },
    { prop: 'updated_at', dir: 'desc' },
    { prop: 'priority', dir: 'desc' },
    { prop: 'deadline', dir: 'desc' }
  ]" [messages]="{emptyMessage: 'Nincs megjeleníthető adat!'}">
            <ngx-datatable-column name="Kérvény neve" prop="data">
              <ng-template let-value="value" let-row="row" ngx-datatable-cell-template style="overflow-wrap:break-word">
                <b class="mobil">Kérvény neve</b>
                <span style="text-wrap: auto;">{{ value.name }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Beküldő neve" prop="data">
              <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                <b class="mobil">Beküldő neve</b>
                <span>{{ value.submission.data.userMetadata.full_name }}</span>
              </ng-template>
            </ngx-datatable-column>
            <!-- Gyermek: ha a kérvényben van gyermekválasztó, itt látszik, kiről szól. -->
            <ngx-datatable-column name="Gyermek" prop="gyermek">
              <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                <b class="mobil">Gyermek</b>
                <span *ngIf="value">{{ value }}</span>
                <span *ngIf="!value" style="color:#999">–</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Beküldés dátuma" prop="date">
              <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                <b class="mobil">Beküldés dátuma</b>
                <span>{{ value | date: 'yyyy. MM. dd.' }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Státusz" prop="status">
              <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                <b class="mobil">Státusz</b>
                <div style="display: flex; align-items: center; gap: 0.5rem;" *ngIf="row.status == '1'">
                  <img src="assets/icon/icons8-leave-96.png" width="32px" title="Ügyintézés alatt">
                  <span>Ügyintézés szükséges</span>
                </div>
                <div style="display: flex; align-items: center; gap: 0.5rem;" *ngIf="row.status == '2'">
                  <img src="assets/icon/icons8-verified-account-96.png" width="32px" title="Elfogadva">
                  <span>Elfogadva</span>
                </div>
                <div style="display: flex; align-items: center; gap: 0.5rem;" *ngIf="row.status == '21'">
                  <img class="ikon-szurke" src="assets/icon/icons8-verified-account-96.png" width="32px" title="Elbírálva">
                  <span>Elbírálva (határozat készült)</span>
                </div>
                <div style="display: flex; align-items: center; gap: 0.5rem;" *ngIf="row.status == '3'">
                  <img src="assets/icon/icons8-minus-96.png" width="32px" title="Elutasítva">
                  <span>Elutasítva</span>
                </div>
                <div style="display: flex; align-items: center; gap: 0.5rem;" *ngIf="row.status == '4'">
                  <img src="assets/icon/icons8-wait-96.png" width="32px" title="Hiánypótlás szükséges">
                  <span>Hiánypótlás szükséges</span>
                </div>
                <div class="dontes-indok" *ngIf="dontesIndoka(row) && (row.status == '3' || row.status == '4')">
                  <b>Indoklás:</b> {{ dontesIndoka(row) }}
                </div>
                <span *ngIf="value != 1">
                  <br>
                  ({{row.ugyintezo}})
                </span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Műveletek">
              <ng-template let-value="value" let-row="row" ngx-datatable-cell-template let-i="rowIndex">
                <b class="mobil">Műveletek</b>
                <!--ion-button color="secondary" size="small" style="margin-top:0" (click)="initForm(row)" disabled>
                  <ion-icon slot="start" name="create"></ion-icon> Hiánypótlás
  
                </ion-button><br-->
                <ion-button color="tertiary" size="small" style="margin-top:0" [href]="'/api/file/'+row.path"
                  [disabled]="!row.path">
                  <ion-icon slot="start" name="download"></ion-icon> Letöltés

                </ion-button>
                <!-- Határozat csak akkor tölthető le, ha készült is: enélkül a letöltés hibára futna -->
                <ion-button color="tertiary" size="small" style="margin-top:0" [href]="'/api/file/'+row.hatpath"
                  [disabled]="!row.hatpath" [title]="row.hatpath ? 'Határozat letöltése' : 'Ehhez a kérvényhez még nem készült határozat'">
                  <ion-icon slot="start" name="download"></ion-icon> Határozat

                </ion-button><br>
                <!-- Egy gomb, a döntés fajtáját (elfogadás / elutasítás / hiánypótlás) a modal kérdezi.
                     Eldöntött kérvénynél is nyitható: a döntés javítható (felülírható), az
                     előzményt a döntés-napló megőrzi. Visszavont kérvényt nem bírálunk el. -->
                <ion-button [color]="row.status == 1 ? 'primary' : 'medium'" size="" style="margin-top:0"
                  (click)="dontesNyitas(row)" [disabled]="row.status == 5"
                  [title]="row.status == 1 ? 'Döntés' : 'A meghozott döntés javítása'">
                  <ion-icon slot="start" name="checkmark-done"></ion-icon>
                  {{ row.status == 1 ? 'Dönt' : 'Döntés módosítása' }}
                </ion-button>
                <!-- ÚJRAGENERÁLÁS: ha a sablon szövegében utólag hibát találunk, a javítás
                     eddig csak az ezutáni beküldésekre hatott. Itt a MEGLÉVŐ kitöltéssel
                     nyílik meg a mai sablon: a beírt adatok megmaradnak, a régi PDF pedig
                     a fájltárban marad (az útvonala a döntésnaplóba kerül). -->
                <ion-button color="warning" size="" fill="outline" style="margin-top:0"
                  (click)="ujrageneralas(row)" [disabled]="!ujrageneralhato(row)"
                  title="A kérvény újranyomtatása a mai sablonnal, a beküldött adatokkal">
                  <ion-icon slot="start" name="refresh-outline"></ion-icon> Újragenerálás
                </ion-button>
                <!--ion-button color="success" size="small" style="margin-top:0" (click)="initModal2(JSON.parse(row.users)[0],0)">
                  <ion-icon slot="icon-only" name="add-circle"></ion-icon>
  
                </ion-button>
                <ion-button color="tertiary" size="small" style="margin-top:0" (click)="initModal3(JSON.parse(row.users)[0],0)">
                  <ion-icon slot="icon-only" name="document"></ion-icon>
  
                </ion-button-->
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </ng-container>



      </ion-col>
    </ion-row>



  </ion-grid>




    <!-- LEADÁS-ELLENŐRZÉS: kiválasztott kérvényhez ki nem adta le még. Ha a kérvényben
         van gyermekválasztó, a hiány TANULÓNKÉNT értendő (a beküldésben tárolt gyerek
         neve alapján), egyébként a beküldő felhasználó szerint. -->
    <ion-row *ngIf="menu == 7">
      <ion-col>
        <ion-card>
          <ion-card-content>
            <div style="display:flex;gap:12px;flex-wrap:wrap;align-items:flex-end">
              <ion-select style="min-width:320px;max-width:520px" fill="outline" label="Kérvény"
                labelPlacement="stacked" interface="popover" [(ngModel)]="leadasKerveny"
                (ngModelChange)="leadasBetolt()" placeholder="Válassz kérvényt">
                <ion-select-option *ngFor="let f of csakkerveny" [value]="f.id">{{f.name}}</ion-select-option>
              </ion-select>
              <ion-select style="min-width:200px" fill="outline" label="Kit várunk el" labelPlacement="stacked"
                interface="popover" [(ngModel)]="leadasKor" (ngModelChange)="leadasBetolt()">
                <ion-select-option value="">Automatikus</ion-select-option>
                <ion-select-option value="tanulo">Tanulók</ion-select-option>
                <ion-select-option value="szulo">Gondviselők</ion-select-option>
                <ion-select-option value="allomany">Munkatársak</ion-select-option>
              </ion-select>
              <ion-input style="min-width:180px" fill="outline" label="Keresés" labelPlacement="stacked"
                placeholder="név vagy osztály" [(ngModel)]="leadasKereses"></ion-input>
              <ion-button size="small" color="secondary" (click)="leadasBetolt()" [disabled]="!leadasKerveny">
                <ion-icon slot="start" name="refresh"></ion-icon>Frissítés
              </ion-button>
              <ion-button size="small" fill="outline" (click)="leadasEmailMasol()"
                [disabled]="!leadasEredmeny?.hianyzo?.length">
                <ion-icon slot="start" name="mail-outline"></ion-icon>Hiányzók e-mail címei
              </ion-button>
            </div>

            <ng-container *ngIf="leadasEredmeny">
              <div style="display:flex;gap:8px;flex-wrap:wrap;margin:12px 0">
                <ion-chip color="medium">Elvárt: <b>&nbsp;{{leadasEredmeny.osszes}}</b></ion-chip>
                <ion-chip color="success">Leadta: <b>&nbsp;{{leadasEredmeny.leadott_db}}</b></ion-chip>
                <ion-chip color="danger">Hiányzik: <b>&nbsp;{{leadasEredmeny.hianyzo_db}}</b></ion-chip>
                <ion-chip color="warning" *ngIf="leadasEredmeny.visszavont_db">
                  Visszavont: <b>&nbsp;{{leadasEredmeny.visszavont_db}}</b>
                </ion-chip>
                <ion-chip color="tertiary" *ngIf="leadasEredmeny.kerveny?.gyermek_valaszto">
                  Gyermekválasztós kérvény
                </ion-chip>
              </div>

              <h4 style="margin:8px 0">Nem adta le ({{leadasSzurt(leadasEredmeny.hianyzo).length}})</h4>
              <div class="scrollable-table">
                <table style="width:100%;border-collapse:collapse;font-size:13px">
                  <thead>
                    <tr style="background:#f2f4f8">
                      <th style="text-align:left;padding:6px">Név</th>
                      <th style="text-align:left;padding:6px" *ngIf="leadasEredmeny.kor == 'tanulo'">Osztály</th>
                      <th style="text-align:left;padding:6px">{{ leadasEredmeny.kor == 'tanulo' ? 'Gondviselő' : 'E-mail' }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let h of leadasSzurt(leadasEredmeny.hianyzo)" style="border-bottom:1px solid #eee">
                      <td style="padding:6px">{{h.nev}}</td>
                      <td style="padding:6px" *ngIf="leadasEredmeny.kor == 'tanulo'">{{h.csoport}}</td>
                      <td style="padding:6px">
                        <span *ngIf="leadasEredmeny.kor == 'tanulo'">
                          <span *ngFor="let sz of h.szulok; let last = last">
                            {{sz.nev}} <small style="color:#777">&lt;{{sz.email || '—'}}&gt;</small>{{ last ? '' : ', ' }}
                          </span>
                          <span *ngIf="!h.szulok?.length" style="color:#c00">nincs rögzített gondviselő</span>
                        </span>
                        <span *ngIf="leadasEredmeny.kor != 'tanulo'">{{h.email || '—'}}</span>
                      </td>
                    </tr>
                    <tr *ngIf="!leadasSzurt(leadasEredmeny.hianyzo).length">
                      <td colspan="3" style="padding:10px;color:#2a7">Mindenki leadta.</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <h4 style="margin:16px 0 8px">Leadta ({{leadasEredmeny.leadott?.length || 0}})</h4>
              <div class="scrollable-table">
                <table style="width:100%;border-collapse:collapse;font-size:13px">
                  <thead>
                    <tr style="background:#f2f4f8">
                      <th style="text-align:left;padding:6px" *ngIf="leadasEredmeny.kerveny?.gyermek_valaszto">Gyermek</th>
                      <th style="text-align:left;padding:6px">Beküldő</th>
                      <th style="text-align:left;padding:6px">Beküldve</th>
                      <th style="text-align:left;padding:6px">Állapot</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let l of leadasEredmeny.leadott" style="border-bottom:1px solid #eee">
                      <td style="padding:6px" *ngIf="leadasEredmeny.kerveny?.gyermek_valaszto">{{l.gyermek || '—'}}</td>
                      <td style="padding:6px">{{l.bekuldo || l.user}}</td>
                      <td style="padding:6px">{{l.date | date: 'yyyy. MM. dd.'}}</td>
                      <td style="padding:6px">{{statuszNev(l.status)}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </ng-container>
            <ion-note color="medium" *ngIf="!leadasEredmeny && !leadasFut" style="display:block;margin-top:12px">
              Válassz egy kérvényt: megmutatjuk, ki nem adta le még – gyermekválasztós
              kérvénynél tanulónként, egyébként beküldőnként.
            </ion-note>
            <ion-note color="medium" *ngIf="leadasFut" style="display:block;margin-top:12px">Betöltés…</ion-note>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>

  <ion-modal class="" style="z-index: 1000" #dontesmodal trigger="dontes">
    <ng-template>
      <ion-header>
        <ion-toolbar color="primary">
          <ion-buttons slot="start">
            <ion-button (click)="cancel()">Mégse</ion-button>
          </ion-buttons>
          <ion-buttons slot="end">
            <ion-button style="background: white; border-radius: 5px" (click)="dontes()" [strong]="true" shape="round"
              color="secondary">Mentés</ion-button>
          </ion-buttons>
          <ion-title>Új döntés</ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding" style="margin: auto;text-align: center;">
        <p *ngIf="dontesSor" style="text-align:left">
          <b>{{ dontesSor?.data?.name }}</b><br>
          <small>Beküldő: {{ dontesSor?.data?.submission?.data?.userMetadata?.full_name || dontesSor?.user }}</small>
          <span *ngIf="dontesSor?.gyermek"><br><small>Gyermek: <b>{{ dontesSor.gyermek }}</b></small></span>
        </p>
        <!-- Már megszületett döntés javítása: látszódjon, mi az érvényes állapot. -->
        <ion-note color="warning" *ngIf="dontesSor && dontesSor.status != 1"
                  style="display:block;text-align:left;font-size:.82rem;margin-bottom:8px">
          Ez a kérvény már el van bírálva: <b>{{ statuszNev(dontesSor.status) }}</b><span *ngIf="dontesIndoka(dontesSor)"> – {{ dontesIndoka(dontesSor) }}</span>.
          Az új döntés felülírja az eddigit, az előzmény a döntés-naplóban megmarad.
        </ion-note>
        <ion-segment [(ngModel)]="dontesTipus" mode="ios" color="primary">
          <ion-segment-button value="elfogad">
            <ion-label style="color:green">Elfogadás</ion-label>
          </ion-segment-button>
          <ion-segment-button value="elutasit">
            <ion-label style="color:red">Elutasítás</ion-label>
          </ion-segment-button>
          <ion-segment-button value="hianypotlas">
            <ion-label style="color:orange">Hiánypótlás</ion-label>
          </ion-segment-button>
          <!-- Ha tévedésből született döntés: vissza ügyintézés alá, hogy újra elbírálható legyen. -->
          <ion-segment-button value="ujranyit" *ngIf="dontesSor && dontesSor.status != 1">
            <ion-label style="color:#555">Vissza ügyintézés alá</ion-label>
          </ion-segment-button>

        </ion-segment>
        <br>

        <ion-textarea style="text-align: left;" [autoGrow]="true" [(ngModel)]="dontesIndoklas"
          [label]="dontesTipus === 'elfogad' ? 'Döntés indoka (nem kötelező)' : 'Döntés indoka (kötelező)'"
          fill="outline" labelPlacement="stacked"
          placeholder="Ezt a szöveget a beküldő is látni fogja"></ion-textarea>
        <ion-note color="medium" style="display:block;text-align:left;font-size:.78rem;margin-top:4px">
          Az indoklás megjelenik a beküldőnél a „Beküldött kérvények" listában.
          Elutasításnál és hiánypótlásnál kötelező.
        </ion-note>
        <ion-note color="medium" *ngIf="dontesTipus === 'ujranyit'"
                  style="display:block;text-align:left;font-size:.78rem;margin-top:4px">
          A kérvény visszakerül „ügyintézés szükséges" állapotba, és újra elbírálható.
        </ion-note>
        <br>
        <!-- Határozat generálása: csak elfogadásnál és csak akkor, ha a kérvényhez
             tartozik határozatsablon. Mentés után a határozat szerkesztője nyílik meg. -->
        <ion-item lines="none" *ngIf="dontesTipus === 'elfogad'">
          <ion-checkbox labelPlacement="start" style="width:100%"
            [disabled]="!dontesHatarozatSablon"
            [checked]="dontesHatarozatGeneralas"
            (ionChange)="dontesHatarozatGeneralas = $event.detail.checked">
            Határozat generálása
          </ion-checkbox>
        </ion-item>
        <ion-note color="medium" style="display:block;text-align:left;font-size:.78rem"
                  *ngIf="dontesTipus === 'elfogad'">
          <ng-container *ngIf="dontesHatarozatSablon">
            Mentés után megnyílik a határozat szerkesztője, a kérvény adataival előtöltve.
          </ng-container>
          <ng-container *ngIf="!dontesHatarozatSablon">
            Ehhez a kérvényhez nincs határozatsablon rendelve, ezért határozat nem generálható.
          </ng-container>
        </ion-note><br>
      </ion-content>
    </ng-template>
  </ion-modal>
  <ion-modal class="" style="z-index: 1000" #atadasmodal trigger="atadas">
    <ng-template>
      <ion-header>
        <ion-toolbar color="primary">
          <ion-buttons slot="start">
            <ion-button (click)="cancel()">Mégse</ion-button>
          </ion-buttons>
          <ion-title>Feladat átadása</ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding" style="margin: auto;text-align: center;">

      </ion-content>
    </ng-template>
  </ion-modal>

</ion-content>
